import { ActionTypes as action } from "./action-types";
import newsService from "../../../api/newsService";

const actions = {
    async getNewsListByCompanyId({ commit }, id) {
        const data = await newsService.getNewsListById(id);
        commit(action.GET_NEWS_LIST_BY_ID, data);
        return data;
    },
    async getNewsSettingByCompanyId({ commit }, id) {
        const data = await newsService.getNewsSettingById(id);
        commit(action.GET_NEWS_SETTING_BY_ID, data);
        return data;
    },
    async getAnnouncementList({ commit }) {
        const data = await newsService.getAnnouncementList();
        commit(action.GET_ANNOUNCEMENT_LIST, data);
        return
    },
    async getAnnouncementById({ commit }, id) {
        const data = await newsService.getAnnouncementById(id);
        commit(action.GET_ANNOUNCEMENT_BY_ID, data);
        return data
    },
    async createAnnouncement({ dispatch }, data) {
        const result = await newsService.createAnnouncement(data);
        return result
    },
    async updateAnnouncement({ dispatch }, data) {
        const result = await newsService.updateAnnouncement(data);
        return result
    },
    async deleteAnnouncement({ dispatch }, id) {
        const result = await newsService.deleteAnnouncement(id);
        return result
    },
    resetState({ commit }) {
        commit(action.RESET_STATE);
    },
};

export default actions;
